<template>
  <div :id="id" class="">
    <!-- /scatter area /-->
  </div>
</template>
<script>
import Echarts from "echarts/lib/echarts.js";
import "echarts/lib/chart/scatter.js";
import "echarts/lib/component/legend";
import "echarts/lib/component/title";
import "echarts/lib/component/tooltip";

export default {
  props: {
    code: {
      type: String,
      default: ""
    },
    target: {
      type: String,
      default: ""
    },
    name: {
      type: String,
      default: ""
    },
    score: {
      type: Number,
      default: 0
    },
    rate: {
      type: Number,
      default: 0
    },
    type: {
      type: Number,
      default: 1
    }
  },
  data: function() {
    return {
      id: `scatter-${Date.now()}-${Math.random()
        .toString(16)
        .replace(".", "")}`,
      scatter: null,
      is_mounted: false
    };
  },
  created: function() {
    const that = this;
    const timer = function() {
      if (that.is_mounted) {
        that.buildScatter();
      } else {
        setTimeout(timer, 100);
      }
    };
    timer();
  },
  mounted: function() {
    const that = this;
    that.is_mounted = true;
  },
  methods: {
    buildScatter: function() {
      let that = this;
      if (!that.scatter) {
        that.scatter = Echarts.init(document.querySelector(`#${that.id}`));
      }
      that.$http
        .get("/api/v1/evaluate_records/score_distribution", {
          params: { code: that.code, tg: that.target, type: that.type }
        })
        .then(res => {
          let bd = res.body;
          if (bd.code === 0) {
            //
            let tmp = {};
            bd.result.forEach(r => {
              let t = Math.ceil(r[0] / 5) * 5;
              let td = tmp[t];
              if (!td) {
                td = [t, 0, "得分分布"];
                tmp[t] = td;
              }
              td[1] = td[1] + r[1];
            });
            let data1 = [];
            for (let prop in tmp) {
              data1.push(tmp[prop]);
            }
            var data = [
              // bd.result.map(r => {
              //   r.push("得分分布");
              //   return r;
              // }),
              data1,
              [
                [
                  Math.ceil(that.score / 5) * 5,
                  tmp[Math.ceil(that.score / 5) * 5][1],
                  "我的得分"
                ]
              ]
            ];
            let options = {
              title: {
                show: "true",
                text: `${that.name}`
              },
              // tooltip: {
              //   trigger: "axis",
              //   formatter: function(series) {
              //     let s1 = series[0];
              //     return `得分:${s1.data[0]} 人数:${s1.data[1]}`;
              //   }
              // },
              legend: {
                right: 10,
                data: ["得分分布", "我的得分"]
              },
              grid: {
                left: "3%",
                bottom: "3%",
                containLabel: true
              },
              xAxis: {
                name: "(分)",
                nameGap: 5,
                splitLine: {
                  lineStyle: {
                    type: "dashed"
                  }
                },
                max: 100,
                type: "value"
              },
              yAxis: {
                name: "(人数)",
                type: "value",
                splitLine: {
                  lineStyle: {
                    type: "dashed"
                  }
                }
              },
              series: [
                {
                  name: "得分分布",
                  data: data[0],
                  type: "scatter",
                  symbolSize: function(data) {
                    return 4 * Math.sqrt(data[1]);
                  },
                  label: {
                    emphasis: {
                      show: true,
                      formatter: function(param) {
                        return `得分：${param.data[0].toFixed(2)}，人数:${
                          param.data[1]
                        }`;
                      },
                      position: "top"
                    },
                    normal: {
                      formatter: function(param) {
                        return `得分：${param.data[0].toFixed(2)}，人数:${
                          param.data[1]
                        }`;
                      }
                    }
                  },
                  itemStyle: {
                    normal: {
                      // shadowBlur: 10,
                      // shadowColor: "rgba(120, 36, 50, 0.5)",
                      // shadowOffsetY: 5,
                      color: "#fa444b"
                      // color: new Echarts.graphic.RadialGradient(0.4, 0.3, 1, [
                      //   {
                      //     offset: 0,
                      //     color: "rgb(251, 118, 123)"
                      //   },
                      //   {
                      //     offset: 1,
                      //     color: "rgb(204, 46, 72)"
                      //   }
                      // ])
                    }
                  }
                },
                {
                  name: "我的得分",
                  data: data[1],
                  type: "scatter",
                  symbolSize: function(data) {
                    return 4;
                  },
                  label: {
                    normal: {
                      show: true,
                      formatter: function(param) {
                        return "我";
                      },
                      position: "top"
                    }
                  },
                  itemStyle: {
                    normal: {
                      // shadowBlur: 10,
                      // shadowColor: "rgba(25, 100, 150, 0.5)",
                      // shadowOffsetY: 5,
                      color: "rgb(0, 165, 224)"
                      // color: new Echarts.graphic.RadialGradient(0.4, 0.3, 1, [
                      //   {
                      //     offset: 0,
                      //     color: "rgb(129, 227, 238)"
                      //   },
                      //   {
                      //     offset: 1,
                      //     color: "rgb(25, 183, 207)"
                      //   }
                      // ])
                    }
                  }
                }
              ]
            };
            that.scatter.setOption(options);
          }
        });
    }
  },
  destroyed: function() {
    let that = this;
    if (that.scatter) {
      try {
        that.scatter.destroy();
      } catch (e) {}
    }
    if (that.tips) {
      try {
        that.tips.remove();
      } catch (e) {}
    }
  }
};
</script>
<style lang="less">
.scatter-tips {
  display: none;
  position: absolute;
  padding: 10px 10px 0;
  width: 200px;
  left: 0;
  top: 0;
  color: darken(rgb(251, 118, 123), 10%);
  border: 1px solid #333;
  background-color: rgba(40, 40, 40, 0.7);
  border-radius: 5px;
  -moz-box-sizing: border-box;
  box-sizing: border-box;
  -webkit-box-sizing: border-box;
  z-index: 9999999;
  dl {
    margin: 0;
    padding: 0;
    dt {
      font-weight: 700;
    }
    dd {
      margin: 0;
      padding: 10px 0 10px;
    }
  }
}
</style>




// WEBPACK FOOTER //
// scatter.vue?32a5fab8